import { Order } from 'entities/Order/model/types/OrderSchema';

import { orderCanShowPriceLoading } from '../orderCanShowPriceLoading/orderCanShowPriceLoading';

export const orderHasPriceLoading = (order: Order) => {
    if (!orderCanShowPriceLoading(order)) return false;

    return !order.isAllItemChecksFinished;
};
